const API_BASE = process.env.REACT_APP_API_URL || "https://vicshield-staging.up.railway.app";
export default API_BASE;